import { createFileRoute } from '@tanstack/react-router';
import GalleryPageComponent from 'src/Administration/PageContent/PageContentGallery/PageContentGallery';

export const Route = createFileRoute('/systemadmin/_layout/page-content/gallery-page')({
  component: GalleryPageComponent,
});
